import { render, staticRenderFns } from "./DerivativeShippings.vue?vue&type=template&id=ea037486"
import script from "./DerivativeShippings.vue?vue&type=script&lang=js"
export * from "./DerivativeShippings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports